<div
  style="background-image: url('assets/sign-up-bg.svg')"
  class="seller-signup h-screen overflow-y-auto bg-[#BBDEEB] bg-cover bg-no-repeat bg-center"
>
  <div class="container mx-auto flex justify-center px-17.5 pt-12 relative">
    <sham-i-sham-logo-Full class="px-2 absolute top-4 xl:start-17.5 start-12" />

    <div
      class="max-w-[717px] xl:w-[717px] py-8 px-40 pb-10.5 rounded bg-white-light space-y-4"
    >
      <h2 class="font-semibold text-[32px] leading-[36px] p-2.5 text-center mb-2">
        Reset Password
      </h2>

      <p class="text-center text-sm text-[#6D6D6D] mb-4">
        @if (step() === 1) {
          Enter your email address and we'll send you an OTP code.
        } @else {
          Enter the OTP code sent to your email and create a new password.
        }
      </p>

      <section class="space-y-4">
        <div class="relative overflow-hidden">
          @if (step() === 1) {
            <div class="step space-y-4">
              <dx-form
                [formData]="requestOtpFormData()"
                [colCount]="1"
                [labelLocation]="'top'"
              >
                <dxi-item
                  dataField="email"
                  [label]="{ text: 'Email Address' }"
                  [editorOptions]="emailEditorOptions"
                  [validationRules]="[
                    { type: 'required', message: 'Email is required' },
                    { type: 'email', message: 'Email format is invalid' },
                  ]"
                />
              </dx-form>

              <dx-button
                text="Send OTP"
                type="default"
                stylingMode="contained"
                [width]="'100%'"
                [disabled]="loading()"
                (onClick)="onRequestOtp()"
              />
            </div>
          } @else {
            <div class="step space-y-4">
              <dx-form
                [formData]="verifyOtpFormData()"
                [colCount]="1"
                [labelLocation]="'top'"
              >
                <dxi-item
                  dataField="otp"
                  [label]="{ text: 'OTP Code' }"
                  [editorOptions]="otpEditorOptions"
                  [validationRules]="[
                    { type: 'required', message: 'OTP code is required' },
                    {
                      type: 'pattern',
                      pattern: /^[0-9]{6}$/,
                      message: 'OTP must be 6 digits',
                    },
                  ]"
                />
              </dx-form>

              <dx-button
                text="Verify OTP"
                type="default"
                stylingMode="contained"
                [width]="'100%'"
                [disabled]="loading()"
                (onClick)="onVerifyOtp()"
              />

              <dx-button
                text="Back"
                stylingMode="text"
                [width]="'100%'"
                [disabled]="loading()"
                (onClick)="backToEmailStep()"
              />
            </div>
          }

          @if (submitError()) {
            <p class="text-sm text-red-600 text-center mt-2">
              {{ submitError() }}
            </p>
          }
        </div>

        <div class="text-center text-sm">
          <p>
            Remember your password?
            <a href="/signin" class="text-blue font-semibold">Login</a>
          </p>
        </div>
      </section>
    </div>
  </div>

  <div class="page-footer-copy text-center text-[#6D6D6D] mt-5">
    All rights reserved © Shamsuperstore.com
  </div>
</div>
